'use client'

import { useContext } from 'react'

import { SiteSettingsContext } from '@/providers/SiteSettingsContextProvider'

import type { LayoutSettings, SanityLink } from '@/interfaces/LayoutSettings'

const emptyLayout: LayoutSettings = {
  headers: [],
  footers: [],
  links: [],
}

export function useSiteSettings() {
  const siteSettings = useContext(SiteSettingsContext)
  const currentLayout = siteSettings?.layout ?? emptyLayout

  const getLinkByName = (internalName?: string): SanityLink | undefined => {
    if (!internalName) {
      return undefined
    }

    return currentLayout.links.find((link) => link.internalName === internalName)
  }

  return {
    siteSettings,
    currentLayout,
    getLinkByName,
  }
}
